import {expressApi} from '@/api/axiosClients';

export async function getVotingTrendsListsActivity(nodeId, params) {
  try {
    const result = await expressApi.get(`/v1/voting-trends/${nodeId}/lists-activity`, {params});
    if (!result.status || result.status !== 200) {
      throw new Error('Server Error');
    }
    if (result.data.error) {
      throw new Error(result.data.message || 'Unknown Error');
    }
    return result.data;
  }
  catch (e) {
    console.error(e);
  }
}

export async function getVotingTrendsHighlights(nodeId) {
  const result = await expressApi.get(`/v1/voting-trends/${nodeId}/highlights`);
  if (!result.status || result.status !== 200) {
    throw new Error('Server Error');
  }
  if (result.data.error) {
    throw new Error(result.data.message || 'Unknown Error');
  }
  return result.data;
}

export async function getVotingTrendsExport(nodeId) {
  try {
    const result = await expressApi.get(`/v1/voting-trends/${nodeId}/export`, {responseType: 'blob'});
    if (!result.status || result.status !== 200) {
      throw new Error('Server Error');
    }
    if (result.data.error) {
      throw new Error(result.data.message || 'Unknown Error');
    }
    return result.data;
  }
  catch (e) {
    console.error(e);
  }
}

export async function getVotingTrendsListActivityExport(nodeId, params = {}) {
  try {
    const result = await expressApi.get(`/v1/voting-trends/${nodeId}/lists-activity/export`, {params, responseType: 'blob'});
    if (!result.status || result.status !== 200) {
      throw new Error('Server Error');
    }
    if (result.data.error) {
      throw new Error(result.data.message || 'Unknown Error');
    }
    return result.data;
  }
  catch (e) {
    console.error(e);
  }
}